import { render, staticRenderFns } from "./ResDataTable.vue?vue&type=template&id=3e377d56&scoped=true"
import script from "./ResDataTable.vue?vue&type=script&lang=js"
export * from "./ResDataTable.vue?vue&type=script&lang=js"
import style0 from "./ResDataTable.vue?vue&type=style&index=0&id=3e377d56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e377d56",
  null
  
)

export default component.exports